import moment from 'moment-timezone';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';

import { getListSupplierAutomation, updateSupplierAutomation } from '../../app/store/actions/supplierAutomation';
import { getAllSupplierTelecom, updateSupplierTelecom } from '../../app/store/actions/supplierTelecom';
import ModalComponent from '../../components/modal';
import TableRegisterButton from '../../components/table/registerButton';
import Table from '../../components/table/table';
import ROUTES from '../../data/routes';
import { history } from '../../routers/AppRouter';

class SupplierTelecomPage extends Component {
  constructor(props) {
    super(props);

    this.actions = {
      list: 'getAllSupplierTelecom',
      update: 'updateSupplierTelecom',
    };

    this.state = {
      limit: 10,
      page: 1,
      search: '',
      orderBy: 'DESC',
      field: 'createdAt',
      listSupplierTelecom: [],
      totalRecord: 0,
      showModal: false,
      showCancel: false,
      titleModal: '',
      titleModalBody: '',
      selectedLine: {},
    };

    this.tableHeader = [
      { key: 'description', value: I18n.t('description') },
      { key: 'createdAt', value: I18n.t('createdIn') },
      { key: 'updatedAt', value: I18n.t('changedIn') },
      { key: 'status', value: I18n.t('status') },
      { key: 'action', value: I18n.t('action') },
    ];
  }

  componentDidMount() {
    if(this.props.actions){
      this.actions.list = this.props.actions.list;
      this.actions.update = this.props.actions.update;
    }
    this.getAllSupplierTelecom();
  }

  updateSupplierTelecomStatus = async (parameters = {}) => {
    try {
      await this.props[this.actions.update]({ ...parameters })

      await this.getAllSupplierTelecom();
    } catch (err) {

      const error = err.response && err.response.data && err.response.data.error
      if (error && error.message) {
        const messageError = (error.code && error.details) ?
          `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        this.setState({
          showModal: true,
          showCancel: false,
          titleModal: I18n.t('Error'),
          titleModalBody: messageError
        })
      } else {
        this.setState({
          showModal: true,
          showCancel: false,
          titleModal: I18n.t('Error'),
          titleModalBody: I18n.t('errorOcurred')
        })
      }
    }
  }

  adjustData = async (count = 0, rows = []) => {
    const listSupplierTelecom = rows.map((element, index) => ({
      key: index,
      id: element.id,
      description: element.brand.description,
      brandId: element.brandId,
      mainProvider: element.mainProvider,
      createdAt: moment(element.createdAt).format('L LT'),
      updatedAt: moment(element.updatedAt).format('L LT'),
      status: (
        <div className="row margin-left-0">
          <button
            type="button"
            className={`btn btn-${element.status ? 'warning' : 'dark'} promotion-btn-${element.status ? 'warning' : 'active'}`}
            onClick={() => this.updateSupplierTelecomStatus({
              id: element.id,
              status: !element.status,
              brandId: element.brandId,
              mainProvider: false,
              updateStatus: true,
            })}
          >
            {(element.status)
              ? I18n.t('disable')
              : I18n.t('active')
            }
          </button>
        </div>
      ),
      action: (
        <div className="btn-group" role="group" aria-label="Button group with nested dropdown">
          <div className="btn-group" role="group">
            <button
              id="btnGroupDrop1"
              type="button"
              className="btn btn-secondary dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              {I18n.t('action')}
            </button>
            <div className="dropdown-menu" aria-labelledby="btnGroupDrop1">
              <button
                type="button"
                className="dropdown-item dropdown-table"
                onClick={() => {
                  history.push({
                    pathname: ROUTES.FORM,
                    screenComming: 'supplierTelecom',
                    selectedSupplierTelecom: element,
                    actions: this.props.actions,
                  });
                }
                }
              >
                {I18n.t('edit')}
              </button>
            </div>
          </div>
        </div>
      ),
    }));

    this.setState({
      totalRecord: count,
      listSupplierTelecom,
    });
  }

  getAllSupplierTelecom = async () => {
    const {
      search, page, limit, orderBy = '', field = '',
    } = this.state;
    const skip = (page - 1) * limit;

    try {
      const { count = 0, rows = [] } = await this.props[this.actions.list](
        limit, skip, search, orderBy, field,
      );

      await this.adjustData(count, rows);
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;
      if (error && error.message) {
        const messageError = (error.code && error.details)
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        this.setState({
          showModal: true,
          showCancel: false,
          titleModal: I18n.t('Error'),
          titleModalBody: messageError,
        });
      } else {
        this.setState({
          showModal: true,
          showCancel: false,
          titleModal: I18n.t('Error'),
          titleModalBody: I18n.t('erroFetch'),
        });
      }
    }
  }

  sortTable = async (field, orderBy) => {
    await this.setState({ orderBy, field });
    await this.getAllSupplierTelecom();
  }

  searchTable = async (search = '', page = 1) => {
    await this.setState({ search, page });
    await this.getAllSupplierTelecom();
  }

  confirmModal = async () => {
    this.setState({ showModal: false });
  }

  tableButtons = () => (
    <React.Fragment>
      <TableRegisterButton route={{ 
        pathname: ROUTES.FORM, 
        screenComming: 'supplierTelecom',
        actions: this.props.actions,
     }} />
    </React.Fragment>
  )

  render() {
    const {
      limit, page, listSupplierTelecom, totalRecord, titleModal, titleModalBody, showModal, showCancel,
    } = this.state;

    return (
      <div className="main-div-tables">
        <ModalComponent
          title={titleModal}
          showCancel={showCancel}
          body={titleModalBody}
          visible={showModal}
          closeModal={() => this.setState({ showModal: false })}
          titleOkButtoon={I18n.t('ok')}
          size={{ width: '400px', height: '250px' }}
          showButtons
          confirmModal={this.confirmModal}
        />
        <Table
          title={I18n.t('supplier')}
          buttons={this.tableButtons()}
          header={this.tableHeader}
          lines={listSupplierTelecom}
          page={page}
          perPage={limit}
          count={totalRecord || 0}
          searchItems={this.searchTable}
          showItemsCount
          sortTable={this.sortTable}
        />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getAllSupplierTelecom: (limit, skip, search, orderBy, field) => dispatch(getAllSupplierTelecom(limit, skip, search, orderBy, field)),
  updateSupplierTelecom: (updSupplierTelecom) => dispatch(updateSupplierTelecom(updSupplierTelecom)),
  getListSupplierAutomation: (limit, skip, search, orderBy, field) => dispatch(getListSupplierAutomation(limit, skip, search, orderBy, field)),
  updateSupplierAutomation: (updSupplierTelecom) => dispatch(updateSupplierAutomation(updSupplierTelecom)),
});

const mapStateToProps = () => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(SupplierTelecomPage);